/**
 * Configuration 페이지 공용 상태 훅
 * LITE/MINI가 공유하는 기기/설정/편집/연결 상태를 한 곳에서 관리한다.
 * 기존 useDeviceState + useConfigState를 대체하며 MINI 페이지의 인라인 상태와 패턴을 통일한다.
 */
import { useCallback, useState } from 'react';
import { DeviceType } from '@packages/types/device/common/deviceTypes';

export function useConfigPageState<TDevice, TConfig>(
  skeletonDevice: TDevice,
  skeletonConfig: TConfig
) {
  const [detectedDeviceType, setDetectedDeviceType] = useState<DeviceType | null>(null);
  const [curDevice, setCurDevice] = useState<TDevice | null>(skeletonDevice);
  const [deviceConfigData, setDeviceConfigData] = useState<TConfig>(skeletonConfig);
  const [editingCard, setEditingCard] = useState<number | null>(null);
  const [configDeviceSerial, setConfigDeviceSerial] = useState<string | null>(null);

  const resetState = useCallback(() => {
    setDetectedDeviceType(null);
    setCurDevice(skeletonDevice);
    setDeviceConfigData(skeletonConfig);
    setEditingCard(null);
    setConfigDeviceSerial(null);
  }, [skeletonDevice, skeletonConfig]);

  return {
    detectedDeviceType,
    setDetectedDeviceType,
    curDevice,
    setCurDevice,
    deviceConfigData,
    setDeviceConfigData,
    editingCard,
    setEditingCard,
    configDeviceSerial,
    setConfigDeviceSerial,
    resetState,
  };
}
